import React from 'react';
import cs from 'classnames';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';

import Button from '~/components/common/Button';
import mapDispatch from '~/misc/mapDispatch';
import {setUserProps} from '~/misc/metrics';
import {reportJobTitle} from '~/modules/user/actions';

import css from './index.css';

const toSpecifyLegacy = {
  'Private Fleet Dispatcher': true,
  'Dedicated Fleet Dispatcher': true,
};

const toSpecify = {
  ...toSpecifyLegacy,
  'Fleet/Company Dispatcher...': true,
};

const specified = {
  'Fleet Dispatcher (Production/Goods Company)': true,
  'Fleet Dispatcher (Trucking Company)': true,
};

const submit = (fields, redirectTo) => {
  if (!fields.job || toSpecify[fields.job]) {
    return null;
  }

  const jobNameDesc = fields.desc || null;

  setUserProps({jobName: fields.job, jobNameDesc});
  return (dispatch) => {
    dispatch(reportJobTitle({title: fields.job, desc: jobNameDesc}));
    if (redirectTo) {
      dispatch(changeURL(redirectTo));
    }
  };
};

const fleetJobs = [
  'Fleet Dispatcher (Production/Goods Company)',
  'Fleet Dispatcher (Trucking Company)',
  'Fleet Owner',
  'Other',
];

const jobs = [
  'Independent Dispatcher',
  'Fleet/Company Dispatcher...',
  null,
  'Leased Owner Operator',
  'Owner Operator',
  'Owner Operator Assistant',
  'Fleet Owner',
  null,
  'Broker',
  'Fleet Driver',
  'Other',
];

const InputItem = ({input, jobName}) => (<span>
  <label className={css.option}>
    <input
      {...input}
      name='job'
      type='radio'
      value={jobName}
      checked={input.value === jobName}
    />
    {' '}
    <span>{jobName}</span>
  </label>{' '}
</span>);

const Inputs = ({fields}) => (<div>
  Which of these job titles does describe you best?
  <br/>
  {jobs.map((jobName, i) => {
    if (!jobName) {
      return <span className={css.inputsBreak} key={i}/>;
    }

    return <InputItem input={fields.job} jobName={jobName} key={i}/>;
  })}
</div>);

const SelectedInputs = ({fields}) => {
  const value = fields.job.value;
  if (toSpecify[value] || specified[value]) {
    return (<div>
      <span>Which of these job titles does describe your company best?</span>
      <br/>
      {fleetJobs.map((jobName, i) => <InputItem input={fields.job} jobName={jobName} key={i}/>)}
    </div>);
  }

  if (value === 'Other') {
    return (<div>
      How would you describe your company and your job? <br/>
      <label className={css.option}>
        <input type='checkbox' {...fields.job} checked={true}/>
        {' '}
        <span>Other</span>
      </label>{' '}
      <input type='text' {...fields.desc} size={30} placeholder='Your job title or description'/>
    </div>);
  }

  return <Inputs fields={fields}/>;
};

const UserJobBannerForm = reduxForm({
  form: 'userJob',
  fields: ['job', 'desc'],
})((props) => (
  <div
    className={cs((!props.noWrap && css.wrap), 'qa-user-job-banner')}
  >
    <form data-qa='user-job-from'>
      <div className={css.row}>
        <div className={css.message}>

          <SelectedInputs fields={props.fields}/>
        </div>

        <div className={css.fromPart}>
          <div className={css.submit} >
            <Button
              submit={true}
              mods={['wide', 'inputSize']}
              onClick={!props.submitting && props.handleSubmit}
            >
              {props.submitting ? '...' : 'Submit'}
            </Button>
          </div>
        </div>
      </div>
    </form>
  </div>
));


const UserJobBanner = ({polled, onSubmit, noWrap, jobName, jobNameDesc}) => {
  if (polled && !toSpecifyLegacy[jobName] && (jobName !== 'Other' || jobNameDesc)) {
    return null;
  }

  return (<UserJobBannerForm
    noWrap={noWrap}
    onSubmit={onSubmit}
    initialValues={({job: jobName, desc: jobNameDesc})}
  />);
};

export default connect(
  ({user}) => ({
    polled: user.jobTitleReported,
    jobName: user.jobName,
    jobNameDesc: user.jobNameDesc,
  }),
  mapDispatch({
    onSubmit: (props, fields) => submit(fields, props.redirectTo),
  })
)(UserJobBanner);



// WEBPACK FOOTER //
// ./src/components/common/UserJobBanner/index.js